<template>
  <div>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-unfold"></i>项目信息</b></div>
      <div class=' contijiao wkbmf loaded' v-if="!endjiezhi">
        <div class='stamp '></div>
      </div>
      <div class="text item text-center tableheight1" style="width:100%;height:60px;">
        <div class="pull-right" style="margin-bottom: 15px">
          <el-button type="warning" plain @click.native="downfile()" size="medium">招标文件下载</el-button>
          <el-button type="primary" plain size="medium" @click.native="checktable('1')"
            :disabled="!endjiezhi">信息暂存</el-button>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain size="medium" @click.native="checktable('2')"
              :disabled="!endjiezhi">完成提报</el-button>
          </Debounce>
          <el-button type="primary" plain size="medium" @click.native="PriceSubmit('unvery')"
            :disabled="!chaoshicfinish">撤销提报</el-button>

          <el-button type="info" plain size="medium" @click.native="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click.native="returnpage('2')">返回首页</el-button>
        </div>
      </div>
      <!--  -->
      <div style="width:100%">
        <el-row class="rowdig">
          <el-col :span="6" class="infodata1">
            <span><b>项目编号:</b></span> <span>{{informdata.cprocode}}</span>
          </el-col>
          <el-col :span="12" class="infodata1">
            <span><b>项目名称:</b></span> <span>{{informdata.cproname}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>公告日期:</b></span style="color:red">
            <span>{{informdata.dprodate.substring(0,10)+" "+informdata.dprodate.substring(12,9999)}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>采购方式:</b></span> <span>{{informdata.cprotype}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>商务联系人:</b></span> <span>{{informdata.clinkop}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>联系电话:</b></span> <span>{{informdata.clinktel}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>报价截止日期:</b></span> <span style="color:red">{{informdata.denddate.substring(0,10)+"
              "+informdata.denddate.substring(12,9999)}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>开标方式:</b></span> <span>{{informdata.copentype}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>是否讲标:</b></span> <span>{{informdata.cisspeak}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>税票类型:</b></span> <span>{{informdata.cvouchtype}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>开标时间:</b></span>
            <span style="color:red">{{informdata.dopendate.substring(0,10)+"
              "+informdata.dopendate.substring(12,9999)}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>是否缴纳保证金:</b></span> <span>{{informdata.cisbzj}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b>保证金金额（万元）:</b></span> <span>{{informdata.ibzjmoney}}</span>
          </el-col>
          <el-col :span="6" class="infodata1">
            <span><b> 保证金截止日期:</b></span>
            <span style="color:red">{{informdata.dbzjend.substring(0,10)}}</span>
          </el-col>
          <el-col :span="12" class="infodata1">
            <span><b>开标地址:</b></span> <span>{{informdata.caddress}}</span>
          </el-col>
          <el-col :span="12" class="infodata1">
            <span><b>开户银行:</b></span> <span>{{informdata.cbankname}}</span>
          </el-col>
          <el-col :span="12" class="infodata1">
            <span><b>银行账号:</b></span> <span>{{informdata.cbankcode}}</span>
          </el-col>
          <el-col :span="12" class="infodata1">
            <span><b>备注:</b></span> <span>{{informdata.cnote}}</span>
          </el-col>

        </el-row>
      </div>
    </el-card>
    <el-card class="box-card boxcard" v-if="informdata.cclass=='物资'">
      <div slot="header" class="clearfix">
        <b> <i class="el-icon-s-unfold"></i>标的信息</b>
        <span :style="'color:'+color+';margin-left:15px'">{{spantitle}}</span>
      </div>
      <el-table :data="tableData" border style="width: 100%" highlight-current-row
        :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" border
        class="tb-edit">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="cinvname" label="名称" width="200"></el-table-column>
        <el-table-column prop="cinvstd" label="规格" width="80"></el-table-column>
        <el-table-column prop="cunit" label="单位" width="80"></el-table-column>
        <el-table-column prop="iqty" label="数量" width="80"></el-table-column>
        <el-table-column label="单价" width="110">
          <template slot-scope="scope">
            <el-input size="small" v-model="scope.row.itaxeprice" v-if="endjiezhi"
              oninput="value=value.replace(/[^\d.]/g,'')"></el-input>
            <span>{{scope.row.itaxeprice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="itaxemoney" label="金额" width="80"></el-table-column>
        <el-table-column prop="itax" label="税额" width="80"></el-table-column>
        <!-- <el-table-column prop="cvenremark" label="备注" min-width="180"></el-table-column> -->
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-input size="small" type="textarea" v-model="scope.row.cvenremark" placeholder="请输入备注"
              v-if="endjiezhi"></el-input>
            <span>{{scope.row.cvenremark}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="cremark" label="招标备注" min-width="180"></el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card boxcard" v-else>
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>标的信息</b>
      </div>
      <el-table :data="tableData" border style="width: 100%" highlight-current-row
        :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="cinvname" label="报价项目" width="200"></el-table-column>
        <el-table-column prop="cunit" label="单位" min-width="80"></el-table-column>
        <el-table-column prop="itaxmoney" label="报价" min-width="80"></el-table-column>
        <el-table-column prop="cvenremark" label="备注" min-width="180"></el-table-column>
        <el-table-column prop="cremark" label="招标备注" min-width="180"></el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>响应文件上传</b>
      </div>

      <el-table :data="xyfiledata" border style="width: 100%" highlight-current-row
        :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">

        <el-table-column prop="cfileclass" label="文件名称" width="200"></el-table-column>
        <el-table-column prop="cfiletype" label="文件类型" width="80"></el-table-column>
        <el-table-column prop="cfilenote" label="标价文件说明" min-width="80"></el-table-column>
        <el-table-column prop="dupdate" label="上传时间" width="120"></el-table-column>
        <el-table-column prop="cup" label="是否必须上传" width="100"></el-table-column>
        <el-table-column prop="cvenfilenote" label="上传备注" min-width="180"></el-table-column>
        <el-table-column prop="name" label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain @click="upfile(scope.row, scope.$index)"
              v-if="endjiezhi">上传</el-button>
            <el-button size="mini" type="warning" plain @click="read(scope.row)" v-if="scope.row.cdemopath!=''"
              plain>预览</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>付款条款</b>

      </div>
      <div class="pull-right" style="margin-bottom: 15px" v-if="endjiezhi">
        <el-button size="mini" type="success" class="pull-right" @click="addtable()">新增</el-button>
      </div>

      <el-table :data="cpayData" border style="width: 100%" highlight-current-row
        :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">

        <el-table-column prop="cpaylevel" label="付款阶段" width="200"></el-table-column>
        <el-table-column prop="ipayrate" label="付款比率%" min-width="80"></el-table-column>
        <el-table-column prop="ipaymoney" label="付款金额" min-width="80"></el-table-column>
        <el-table-column prop="ipaynote" label="付款说明" min-width="180"></el-table-column>
        <el-table-column prop="name" label="操作" width="160" v-if="endjiezhi">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="cpayregit(scope.row, scope.$index)">修改</el-button>
            <el-button size="mini" type="danger" @click="del(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog title="文件下载" :visible.sync="disfiles" customClass="filedown" :append-to-body="true"
        :before-close="quxiao">
        <el-table :data="fileData" border style="width: 100%" highlight-current-row
          :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
          <el-table-column prop="cbidfilename" label="文件名称" width="200"></el-table-column>
          <el-table-column prop="cbidfilenote" label="备注" min-width="80"></el-table-column>
          <el-table-column prop="name" label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" @click="down(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="quxiao">关闭</el-button>
        </span>
      </el-dialog>
      <el-dialog title="付款条款" :visible.sync="diviscpay" customClass="unpdatepassword" :append-to-body="true"
        :before-close="quxiao">
        <el-form :model="cpayform" :rules="dataRule" ref="cpayform" v-if="diviscpay" class="demo-dynamic"
          label-width="100px">
          <el-form-item label="付款阶段" prop="cpaylevel">
            <el-input type="text" v-model="cpayform.cpaylevel"></el-input>
          </el-form-item>
          <el-form-item label="付款比率%" prop="ipayrate">
            <el-input type="text" v-model="cpayform.ipayrate"></el-input>
          </el-form-item>
          <el-form-item label="付款金额" prop="ipaymoney">
            <el-input type="text" v-model="cpayform.ipaymoney"></el-input>
          </el-form-item>
          <el-form-item label="付款说明" prop="ipaymoney">
            <el-input type="text" v-model="cpayform.ipaynote"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="quxiao">关闭</el-button>
          <el-button type="primary" @click="queren()">确认</el-button>
        </span>
      </el-dialog>
      <el-dialog title="上传文件" :visible.sync="filedis" customClass="unpdatepassword" :append-to-body="true"
        :before-close="quxiao">
        <el-form :model="fileadd" :rules="filerules" v-if="filedis" ref="fileref" class="demo-dynamic"
          label-width="100px">
          <el-form-item label="标价说明" prop="cfilenote">
            <el-input type="text" v-model="fileadd.cfilenote"></el-input>
          </el-form-item>
          <el-form-item label="上传备注" prop="cvenfilenote">
            <el-input type="text" v-model="fileadd.cvenfilenote"></el-input>
          </el-form-item>
          <el-form-item label="文件上传" prop="cfilepath">
            <el-upload style="display:inline-block;margin:0 10px" action="#" :show-file-list="false" ref="uploadFail"
              :accept="fileadd.cfiletype" :before-upload="brforeUploadreImportFail" :auto-upload="false"
              :on-change="handleChangeFail" :file-list="fileListFail">
              <el-button type="success" plain size="medium">{{fileadd.cfileclass}}({{fileadd.cfiletype}})</el-button>
            </el-upload><br>
            <span>{{filename}}</span>
          </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="quxiao">关闭</el-button>
          <el-button type="primary" @click="filequeren()">确认</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
  export default {
    data() {
      return {
        informdata: {
          cbankcode: "",
          cbankname: "",
          cclass: "",
          cisbzj: "",
          cisspeak: "",
          clinkop: "",
          clinktel: "",
          cnote: "",
          copentype: "",
          cprocode: "",
          cproname: "",
          cprotype: "",
          cvouchtype: "",
          dbzjend: "",
          denddate: "",
          dopendate: "",
          dprodate: "",
          ibzjmoney: "",
        },
        spantitle: "",
        color: "",
        endjiezhi: true,
        chaoshicfinish: true,
        tableData: [],
        xyfiledata: [],
        fileData: [],
        suprow: {},

        fileurl: "",
        typeaccept: "",
        disfiles: false,
        diviscpay: false,
        cpayform: {
          cpaylevel: "",
          ipayrate: "",
          ipaymoney: "",
          ipaynote: "",
        },
        dataRule: {
          cpaylevel: [
            { required: true, message: "付款阶段不能为空", trigger: "blur" },
          ],
          ipayrate: [
            { required: true, message: "付款比率不能为空", trigger: "blur" },
          ],
          ipaymoney: [
            { required: true, message: "付款金额不能为空", trigger: "blur" },
          ],
          ipaynote: [
            { required: true, message: "付款说明不能为空", trigger: "blur" },
          ],
        },
        cpayData: [],
        state: "",
        filedis: false,
        fileadd: {},
        filename: "",
        filerules: {
          cfilepath: [{ required: true, message: "请上传文件", trigger: "blur" }],
        },
        fileListFail: [],
      };
    },
    created() {
      if (this.$route.params.tableRadio) {
        this.suprow = this.$route.params.tableRadio;
        sessionStorage.setItem(
          "suprow",
          JSON.stringify(this.$route.params.tableRadio)
        );
      } else {
        var params = JSON.parse(sessionStorage.getItem("suprow"));
        this.suprow = params;
      }
      console.log(this.suprow);
      this.GitHtsigningInfo();
      // this.FileType();
    },
    methods: {
      // 获取文件类型
      FileType() {
        GetFileType({ type: "04" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },
      // 获取信息
      GitHtsigningInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetOp_Proinfo_Details",
          data: { KeyValue: this.suprow.id },
        }).then((res) => {
          console.log(res, "获取信息结果");
          if (res.data.Success) {
            this.informdata = res.data.Data.dt[0];
            if (this.informdata.cfinish == "是") {
              this.endjiezhi = false;
            } else {
              this.endjiezhi = true;
            }
            this.tableData = res.data.Data.dt2;
            this.xyfiledata = res.data.Data.dt4;
            this.cpayData = res.data.Data.dt5;
            this.countdown();
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 剩余时间
      countdown() {
        if (this.informdata.denddate && this.informdata.denddate != "") {
          const end = new Date(this.informdata.denddate); // 定义开始时间且延长1小时
          const now = Date.parse(new Date()); // 获取本地时间
          const msec = end - now;
          // 将时间戳进行格式化00：00的形式
          let day = parseInt(msec / 1000 / 60 / 60 / 24);
          let hr = parseInt((msec / 1000 / 60 / 60) % 24);
          let min = parseInt((msec / 1000 / 60) % 60);
          let sec = parseInt((msec / 1000) % 60);
          this.day = day;
          this.hr = hr > 9 ? hr : "0" + hr;
          this.min = min > 9 ? min : "0" + min;
          this.sec = sec > 9 ? sec : "0" + sec;
          this.color = "red";
          this.spantitle =
            "询价剩余时间" +
            this.day +
            ":" +
            this.hr +
            ":" +
            this.min +
            ":" +
            this.sec;
          if (msec < 0 || this.suprow.cisreport == "已提报") {
            this.color = "#67c23a";
            this.spantitle = "报价通道已关闭";
            this.chaoshicfinish = false;
            return;
          } else {
            const that = this;
            that.chaoshicfinish = true;
            setTimeout(function () {
              that.countdown();
            }, 1000);
          }
        }
      },
      // 文件下载列表
      downfile() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetOp_Proinfo_Details_File",
          data: {
            KeyValue: this.suprow.id,
          },
        }).then((res) => {
          console.log(res, "获取信息结果");
          if (res.data.Success) {
            this.fileData = res.data.Data.dt;
            this.disfiles = true;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 关闭弹框
      quxiao() {
        this.disfiles = false;
        this.diviscpay = false;
        this.filedis = false;
      },
      // 上传
      upfile(row, index) {
        this.fileadd = JSON.parse(JSON.stringify(row));
        this.filename = "";
        this.filedis = true;
        this.state = index;
      },
      read(row) {
        if (row.cfilepath == "") {
          this.$message.error("暂无文件预览！");
          return;
        }
        let urlblob = this.global.bxiosdow + row.cfilepath;
        window.open(urlblob);
      },
      // 确认
      filequeren() {
        this.$refs.fileref.validate((valid) => {
          if (valid) {
            this.xyfiledata[this.state] = this.fileadd;
            this.quxiao();
          }
        });
      },
      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },
      // 上传文件
      brforeUploadreImportFail(file) {
        let varparams = new FormData();
        varparams.append("file", file);
        varparams.append("file", URL.createObjectURL(file));
        varparams.append("cvoucherno", "op_proven_upfile");
        varparams.append("ctype", "");
        varparams.append("cvoucherid", this.fileadd.keyid);

        this.$axios({
          url: "CommonModule/op_Supplier/BaseUploadFile",
          method: "post",
          data: varparams,
          headers: { "Content-Type": "multipart/form-data" },
          timeout: 30000000,
        }).then((res) => {
          console.log(res, "上传结果");
          this.loading = false;
          if (res.data.Success) {
            this.$message({
              howClose: true,
              message: "上传成功",
              type: "success",
            });

            this.filename = res.data.Data.Cname;
            this.fileadd.cfilepath = res.data.Data.Path;
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 新增付款条款
      addtable() {
        this.cpayform = {
          cpaylevel: "",
          ipayrate: "",
          ipaymoney: "",
          ipaynote: "",
          keyid: "",
        };
        this.state = "-1";
        this.diviscpay = true;
      },
      // 保存付款条款
      queren() {
        this.$refs["cpayform"].validate((valid) => {
          if (valid) {
            if (this.state == "-1") {
              this.cpayData.push(this.cpayform);
            } else {
              this.cpayData[this.state] = this.cpayform;
            }
            this.quxiao();
          }
        });
      },
      // 修改付款条款
      cpayregit(row, index) {
        this.cpayform = JSON.parse(JSON.stringify(row));
        this.state = index;
        this.diviscpay = true;
      },
      // 删除付款条款
      del(row, i) {
        this.cpayData.splice(i, 1);
      },
      // 保存和提交
      checktable(type) {
        this.tableData.forEach((item, index) => {
          let no = index + 1;
          if (item.itaxeprice == "" || item.itaxeprice == 0) {
            this.$message.error("标的信息第" + no + "行：单价不能为0和空！");
            throw console.info("信息不完整");
          }
        });
        this.xyfiledata.forEach((item, index) => {
          let no = index + 1;
          if (item.cup == "是") {
            if (item.cfilepath == "") {
              this.$message.error("响应文件上传第" + no + "行：请上传文件！");
              throw console.info("信息不完整");
            }
          }
        });
        if (type == "1") {
          this.SavePrice();
        }
        if (type == "2") {
          this.PriceSubmit("very");
        }
      },
      //  暂存
      SavePrice() {
        console.log(this.tableData);
        this.$axios({
          method: "post",
          url: "CommonModule/op_Supplier/UpdateTenderList",
          data: {
            KeyValue: this.suprow.id,
            priceJson: JSON.stringify(this.tableData),
            upfileJson: JSON.stringify(this.xyfiledata),
            payJson: JSON.stringify(this.cpayData),
          },
        }).then((res) => {
          console.log(res, "暂存结果");

          if (res.data.Success) {
            this.$message.success(res.data.Message);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      //  暂存
      PriceSubmit(type) {
        this.$confirm("请确认是否操作！！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/op_Supplier/VeryTenderInfo",
              data: {
                KeyValue: this.suprow.id,
                cstate: type,
              },
            }).then((res) => {
              console.log(res, "提交");

              if (res.data.Success) {
                this.$message.success(res.data.Message);
                this.GitHtsigningInfo();
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },

      // 删除待办事项中的信息
      removerp() {
        RemovePruchaseToDo({
          KeyValue: this.suprow.id,
        }).then((res) => {
          console.log(res);
        });
      },
      // 下载

      down(row) {
        const a = document.createElement("a");
        let urlblob = this.global.bxiosdow + row.cbidfilepath;

        fetch(urlblob)
          .then((res) => res.blob())
          .then((blob) => {
            // 将链接地址字符内容转变成blob地址
            a.href = URL.createObjectURL(blob);
            console.log(a.href);
            a.download = ""; // 下载文件的名字
            document.body.appendChild(a);
            a.click();
          });
      },

      // 返回
      returnpage(type) {
        sessionStorage.removeItem("params");
        if (type == "1") {
          this.$router.push({ path: "/Invitation/Invitation" });
        } else {
          this.$router.push({ path: "/home" });
        }
      },
    },
  };
</script>
<style scoped>
  .tb-edit .el-input,
  .tb-edit .el-select,
  .tb-edit .el-textarea {
    display: none;
  }

  .tb-edit .current-row .el-input,
  .tb-edit .current-row .el-select,
  .tb-edit .current-row .el-textarea {
    display: block;
  }

  .tb-edit .current-row .el-input+span,
  .tb-edit .current-row .el-select+span,
  .tb-edit .current-row .el-textarea+span {
    display: none;
  }
</style>